const wasteTypeKeyToIconNameMapping: any = {
  CARDBOARD: "Cardboard Icon",
  ALUMINIUMTIN: "Tin Icon",
  BATTERIES: "Battery Icon",
  BOOKS: "Books Icon",
  CARBATTERIES: "Car Battery Icon",
  CARPET: "Carpet Icon",
  CHEMICALS: "Chemicals Icon",
  COOKINGOIL: "Cooking Oil Icon",
  DISCS: "Discs Icon",
  ELECTRICAL: "Electrical Icon",
  ENGINEOIL: "Engine Oil Icon",
  ERF: "ERF Icon",
  FLUORESCENTTUBES: "F Tube Icon",
  FRIDGEFREEZERS: "Fridge Freezer Icon",
  GARDENWASTE: "Garden Icon",
  GREENWASTE: "Garden Icon",
  HARDPLASTICS: "Hard Plastic Icon",
  GASBOTTLES: "Gas Bottles Icon",
  MIXEDGLASS: "Mix Glass Icon",
  CLEARGLASS: "Clear Glass Icon",
  GREENGLASS: "Green Glass Icon",
  BROWNGLASS: "Brown Glass Icon",
  HOUSEHOLD: "Household Icon",
  LDA: "Fridge Freezer Icon",
  LIGHTBULBS: "Light Bulb Icon",
  NEWSPAPERS: "Newspapers Icon",
  PAINT: "Paint Icon",
  PAPER: "Paper Icon",
  PLASTERBOARD: "Plasterboard Icon",
  PLASTIC: "Plastic Icon",
  MATTRESSES: "Mattress Icon",
  METAL: "Metal Icon",
  RUBBLE: "Rubble Soil Icon",
  SMALLAPPLIANCES: "Small Appliances Icon",
  SOIL: "Rubble Soil Icon",
  TEXTILES: "Textiles Icon",
  TVSANDMONITORS: "TV Monitor Icon",
  TYRES: "Tyre Icon",
  UPVCFRAMES: "UPVC Frame Icon",
  WOODANDTIMBER: "Wood Icon",
  WOODCLEAN: "Wood Clean Icon",
  WOODLGT: "Wood LGT Icon",
  SP: "Spare Icon"
};

const unknownIcon = "unknown";

const mapWasteTypeKeyToIconName = (wateTypeKey: string): string => {
  let wasteTypeIconName;
  try {
    wasteTypeIconName = wasteTypeKeyToIconNameMapping[wateTypeKey];
    if (wasteTypeIconName === undefined) {
      wasteTypeIconName = unknownIcon;
    }
  } catch (Excepion) {
    wasteTypeIconName = unknownIcon;
  }
  return wasteTypeIconName;
};

export { wasteTypeKeyToIconNameMapping, mapWasteTypeKeyToIconName };
